import * as React from 'react';

import classify from 'src/utils/classify';

import css from './loading.css';


type Props = {
  className?: string;
  animationDelay?: number;
};

export class ClassLoading extends React.PureComponent<
  Props,
  {
    countingDown: boolean;
  }
> {
  static defaultProps: {
    animationDelay: number;
  } = {
    animationDelay: 400,
  };

  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'PureComponent<Props, { countingDown: boolean; }, any>'.
  state: {
    countingDown: boolean;
  } = {
    countingDown: true,
  };
  // @ts-expect-error - TS2564 - Property 'timeout' has no initializer and is not definitely assigned in the constructor.
  timeout: number;

  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'PureComponent<Props, { countingDown: boolean; }, any>'.
  componentDidMount() {
    // Don't show spinner before a small delay (because the content
    // might actually render within that delay)
    // @ts-expect-error - TS2322 - Type 'Timeout' is not assignable to type 'number'.
    this.timeout = setTimeout(
      () => this.setState({countingDown: false}),
      this.props.animationDelay,
    );
  }

  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'PureComponent<Props, { countingDown: boolean; }, any>'.
  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'PureComponent<Props, { countingDown: boolean; }, any>'.
  render(): null | React.ReactElement<React.ComponentProps<'div'>> {
    if ((this.props.animationDelay ?? 0) > 0 && this.state.countingDown) {
      return null;
    }

    return <div className={classify(css.loading, this.props.className)} />;
  }
}

export const Loading = ({animationDelay = 400, className}: Props) => {
  const [isWaiting, setIsWaiting] = React.useState(true);
  const timeoutId = React.useRef<number | null | undefined>(null);

  React.useEffect(() => {
    // @ts-expect-error - TS2322 - Type 'Timeout' is not assignable to type 'number'.
    timeoutId.current = setTimeout(() => {
      setIsWaiting(false);
      timeoutId.current = null;
    }, animationDelay);

    return () => {
      if (timeoutId.current != null) {
        clearTimeout(timeoutId.current);
      }
    };
  }, []);

  return animationDelay > 0 && !isWaiting ? (
    <div className={classify(css.loading, className)} />
  ) : null;
};

// TODO (kyle): eventually don't make this the default
export default function LoadingPage({
  className,
  loadingClassName,
  animationDelay,
}: {
  className?: string;
  loadingClassName?: string;
  animationDelay?: number;
}): React.ReactElement<React.ComponentProps<'div'>> {
  return (
    <div className={classify(className, css.container)}>
      <Loading className={loadingClassName} animationDelay={animationDelay} />
    </div>
  );
}
